import { render, staticRenderFns } from "./LeadFlowColumn.vue?vue&type=template&id=9a872440&"
import script from "./LeadFlowColumn.vue?vue&type=script&lang=js&"
export * from "./LeadFlowColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports